import { LocalStorage } from 'shared/helpers/localStorage';

// Bridges the gap when a user starts connecting an inbox from onboarding's
// Channel step (ChannelInfoModal.vue) and the flow leaves the onboarding
// shell's own routes entirely — some channels round-trip through an
// external OAuth provider before landing back in the SPA, so the signal
// needs to survive a full-page redirect to a different origin and back,
// in the same tab. localStorage (not sessionStorage) specifically for the
// account-scoping + expiry LocalStorage.setFlag/getFlag already provide:
// without account-scoping, a multi-account admin mid-detour for one
// account could use a stray flag to reach these routes for another;
// without a TTL, an abandoned attempt (closed OAuth popup, cancelled
// consent screen, user just navigates away) would leave the flag set
// indefinitely since nothing but the success path clears it.
const STORE_NAME = 'onboarding_channel_return';
const FLAG_KEY = 'pending';
const EXPIRY_MS = 60 * 60 * 1000;

export const markOnboardingChannelReturn = accountId => {
  LocalStorage.setFlag(STORE_NAME, accountId, FLAG_KEY, EXPIRY_MS);
};

export const hasOnboardingChannelReturn = accountId => {
  return !!LocalStorage.getFlag(STORE_NAME, accountId, FLAG_KEY);
};

export const clearOnboardingChannelReturn = accountId => {
  LocalStorage.deleteFromJsonStore(`${STORE_NAME}::${accountId}`, FLAG_KEY);
};
